import { sortBy } from 'lodash';
import React from 'react';

import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPoint,
  GraphPlotband,
  GraphInstanceProps
} from '../index';
import { FormatDate } from '../../../../libs/time';
import { IEpxCOPD } from '../../../../libs/apps/epxcopd';
import { CHART } from '../../../../config/colors';

const EpxCOPDGraphs: React.FC<GraphInstanceProps> = (props): JSX.Element => {
  const graph: GraphBlueprint<IEpxCOPD> = {
    name: null,
    config: {
      title: {
        text: 'EpxCOPD - Breathing'
      },
      chart: {
        type: 'line'
      },
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: {
          text: null
        }
      },
      yAxis: {
        title: {
          text: 'Breathing'
        },
        max: 1,
        min: -1,
        tickInterval: 1,
        labels: {
          formatter: function () {
            if (this.value === -1) {
              return 'Worse';
            } else if (this.value === 0) {
              return 'Same';
            } else if (this.value === 1) {
              return 'Better';
            }
          }
        }
      },
      responsive: {}
    },
    draw: (sessions, currentOptions) => {
      const options: GraphOptions = {
        series: []
      };
      const series: GraphSeries = {
        type: 'line',
        name: 'Breathing',
        connectNulls: true,
        tooltip: {
          pointFormatter: function (this) {
            let point = `<span style=\"color:${this.color};\">\u25CF</span> ${this.series.name}: <b>`;
            if (this.y === -1) {
              point += 'Worse';
            } else if (this.y === 0) {
              point += 'Same';
            } else if (this.y === 1) {
              point += 'Better';
            }
            point += '</b></span><br/>';
            return point;
          }
        }
      };
      const data: GraphPoint[] = [];
      const plotBands: GraphPlotband[] = [];
      sessions = sortBy(sessions, (session) => session.time);
      for (const [i, session] of sessions.entries()) {
        data.push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: session.breathing,
          x: i
        });
        if (session.sputum === 2 || session.sputum === 3) {
          plotBands.push({
            from: i - 0.35,
            to: i + 0.35,
            color: CHART.PLOT_BAND_DANGER,
            label: {
              text: session.sputum === 2 ? 'More Sputum' : 'Sputum Color'
            }
          });
        }
      }
      series.data = data;
      options.series = [series];
      options.xAxis = {
        ...currentOptions.xAxis,
        plotBands: plotBands
      };
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxCOPD>
      url="/data/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxCOPDGraphs;
